var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:[`table-column-${_vm.field}`, { 'd-none': !this.isVisible, 'centred': this.isCentred }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }